import {nest} from 'd3-collection';

export default function(array, key){
  return nest().key(key).entries(array).map(function(d){
    d.values.key = d.key;
    return d.values;
  });
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-jetpack/src/nestBy.js
// module id = null
// module chunks = 